import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { BRAND_NAME, BRAND_TAGLINE } from "@/lib/brand";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Landing from "@/pages/Landing";
import Intake from "@/pages/Intake";
import Dashboard from "@/pages/Dashboard";
import Cases from "@/pages/Cases";
import CaseDetail from "@/pages/CaseDetail";
import CRM from "@/pages/CRM";
import Documents from "@/pages/Documents";
import Tasks from "@/pages/Tasks";
import TimeBilling from "@/pages/TimeBilling";
import Settings from "@/pages/Settings";

function Router() {
    const location = useLocation();
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/intake" element={<Intake />} />
            <Route
                path="/app"
                element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route index element={<Dashboard />} />
                <Route path="cases" element={<Cases />} />
                <Route path="cases/:caseId" element={<CaseDetail />} />
                <Route path="crm" element={<CRM />} />
                <Route path="documents" element={<Documents />} />
                <Route path="tasks" element={<Tasks />} />
                <Route path="billing" element={<TimeBilling />} />
                <Route path="settings" element={<Settings />} />
            </Route>
        </Routes>
    );
}

export default function App() {
    useEffect(() => {
        document.title = `${BRAND_NAME} — ${BRAND_TAGLINE}`;
    }, []);
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Router />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}
